import Vue from 'vue';

import types from './types';

export default {
  [types.mutations.RECEIVE_ROOMS] (store, payload) {
    console.log('Mutation: RECEIVE_ROOMS', payload);
    Vue.set(store, 'rooms', payload.sort((a, b) => a.position - b.position));
    store.fetch.status = 'done';
  },
  [types.mutations.FETCHING_ROOMS] (store) {
    store.fetch.status = 'pending';
  }
}



// WEBPACK FOOTER //
// ./src/store/modules/room/mutations.js